import fscreen from 'fscreen'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setFullscreen, useIsFullscreen } from '~map-preview/states/ui'

export const useFullscreenToggle = (selector: string) => {
  const dispatch = useDispatch()
  const isFullscreen = useIsFullscreen()

  const toFullScreen = (value) => {
    dispatch(setFullscreen(value))
  }

  useEffect(() => {
    if (typeof document === 'undefined') return

    const handleFullscreenChange = () => {
      if (!fscreen.fullscreenElement) {
        toFullScreen(false)
      }
    }

    if (isFullscreen) {
      if (fscreen.fullscreenEnabled && !fscreen.fullscreenElement) {
        const containerElement = document.querySelector(selector)
        containerElement && fscreen.requestFullscreen(containerElement)
      }
    } else {
      if (fscreen.fullscreenEnabled && !!fscreen.fullscreenElement) {
        fscreen.exitFullscreen()
      }
    }

    fscreen.addEventListener('fullscreenchange', handleFullscreenChange)

    return () => {
      fscreen.removeEventListener('fullscreenchange', handleFullscreenChange)
    }
  }, [isFullscreen, selector, toFullScreen])

  return { active: isFullscreen, toggle: () => toFullScreen(!isFullscreen) }
}
